/*
 * Copyright (c) 2019. Nedaware SL
 */

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export abstract class BasicEntityTableConstants {
    public static readonly PAGINATION_PAGE = '$p-page';
    public static readonly PAGINATION_SIZE = '$p-size';
}
